// 조회 도우미 — v0.3 State.kt 의 조회 함수와 같은 뜻
import { St, type Item, type Session, type Student } from "./types";
import type { View } from "./store";
import { todayStr } from "../lib/date";

export const sessionOrder = (a: Session, b: Session) => a.date.localeCompare(b.date) || a.time.localeCompare(b.time);

export function studentMap(v: View): Map<string, Student> {
  return new Map(v.students.map((s) => [s.id, s]));
}
export const openItems = (v: View, sid: string) => v.items.filter((i) => i.studentId === sid && !i.done);
export const upcoming = (v: View, sid: string) =>
  v.sessions.filter((s) => s.studentId === sid && s.status === St.PLAN && s.date >= todayStr()).sort(sessionOrder);
export const warnsOf = (v: View, sid: string) => v.warns.filter((w) => w.studentId === sid);

/** 그 일정에서 다룰 시험지 = 지금 남은 항목 + 그 일정에서 통과한 항목 */
export const itemsFor = (v: View, s: Session): Item[] =>
  v.items
    .filter((i) => i.studentId === s.studentId && (!i.done || i.doneSession === s.id))
    .sort((a, b) => a.week.localeCompare(b.week, "ko") || a.createdAt - b.createdAt);

export type DayStats = { total: number; done: number; partial: number; noshow: number; waiting: number };
export function stats(v: View, date: string): DayStats {
  const ss = v.sessions.filter((s) => s.date === date && v.students.some((st) => st.id === s.studentId));
  return {
    total: ss.length,
    done: ss.filter((s) => s.status === St.DONE).length,
    partial: ss.filter((s) => s.status === St.PARTIAL).length,
    noshow: ss.filter((s) => s.status === St.NOSHOW).length,
    waiting: ss.filter((s) => s.status === St.PLAN).length,
  };
}

/** 학생 정규 시간표에서 지금 이후 첫 슬롯 — 등록 화면 기본값(v0.3 nextSlot) */
export function nextSlot(st: Student | undefined, from = new Date()): { date: string; time: string } | null {
  if (!st || !st.slots?.length) return null;
  const hm = `${String(from.getHours()).padStart(2, "0")}:${String(from.getMinutes()).padStart(2, "0")}`;
  for (let i = 0; i <= 14; i++) {
    const d = new Date(from.getFullYear(), from.getMonth(), from.getDate() + i);
    const dv = d.getDay() === 0 ? 7 : d.getDay();
    const times = st.slots.filter((s) => s.dow === dv).map((s) => s.time).sort();
    for (const t of times) {
      if (i === 0 && t <= hm) continue;
      const ds = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
      return { date: ds, time: t };
    }
  }
  return null;
}

/** 학생 색(ARGB 정수, v0.3 COLORS) → CSS 색. 데이터 값이라 토큰이 아니다 */
export function studentColor(c: number | undefined): string {
  if (typeof c !== "number") return "var(--color-border-strong)";
  const n = c >>> 0;
  return `rgb(${(n >> 16) & 255} ${(n >> 8) & 255} ${n & 255})`;
}

export function statusVar(status: string): string {
  switch (status) {
    case St.DONE: return "var(--color-status-done)";
    case St.PARTIAL: return "var(--color-status-partial)";
    case St.NOSHOW: return "var(--color-status-noshow)";
    default: return "var(--color-status-plan)";
  }
}
export const statusLabel = (s: string) => (s === St.PLAN ? "대기" : s);
